// extracted by mini-css-extract-plugin
module.exports = {"infoTooltip":"tooltip_infoTooltip__tgzjW","top":"tooltip_top__JjRgZ"};